import { debounce } from "lodash";
import "./brands-list.scss";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTabs = (context) => {
  const brandsSection = context.closest(".shopify-section");
  if (!brandsSection) return;

  const calcHeight = (wrapper) => {
    wrapper.style.opacity = "";
    wrapper.style.height = "";
    var height = parseInt(getComputedStyle(wrapper).height.replace("px", ""));
    while (wrapper.scrollWidth > window.innerWidth) {
      height += 100;
      wrapper.style.height = `${height}px`;
    }
    wrapper.style.opacity = "1";
  };

  const debounceCalcHeight = debounce(() => {
    const activeTabWrapper = brandsSection.querySelector(
      ".panel.active .brands-banner__list__group__letters"
    );
    if (activeTabWrapper) {
      calcHeight(activeTabWrapper);
    }
  });
  ["resize", "orientationchange"].forEach((evt) =>
    window.addEventListener(evt, debounceCalcHeight)
  );

  const tabContainer = brandsSection.querySelector(".tabs__container");
  const tabs = tabContainer.querySelectorAll(".tab");
  const lettersFilter = tabContainer.querySelectorAll(
    ".letters-container .letters-container--item[data-letter]"
  );

  const allBrandsButton = brandsSection.querySelectorAll(".brand-item");
  if (!allBrandsButton) {
    return;
  } else {
    tippy(allBrandsButton, {
      content: (reference) => reference?.nextSibling ?? "",
      maxWidth: 300,
      placement: "right-start",
      animation: "fade",
      theme: "white",
      arrow: false,
      interactive: true,
      offset: [0, 70],
      appendTo: () => document.body,
      sticky: true,
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      const element = e.target;
      const target = element.getAttribute("for");
      const parent = element.parentElement;

      if (!element.classList.contains("active")) {
        const siblingsBrandsList = document
          .getElementById(target)
          .querySelectorAll(".brands-banner__list__group__item");
        siblingsBrandsList.forEach((sibling) => {
          sibling.classList.remove("hide");
          sibling.classList.remove("active");
        });

        lettersFilter.forEach((letterFilter) => {
          if (letterFilter.classList.contains("active")) {
            letterFilter.click();
          }
        });

        const siblings = Array.from(parent.children).filter(
          (child) => child !== element
        );
        siblings.forEach((sibling) => sibling.classList.remove("active"));
        element.classList.add("active");

        const activeListWrapper = document.getElementById(target);
        activeListWrapper.classList.add("active");
        calcHeight(
          activeListWrapper.querySelector(
            ".brands-banner__list__group__letters"
          )
        );
      }
    });
  });

  lettersFilter.forEach((letterFilter) => {
    const letter = letterFilter.dataset.letter;
    const otherLetterFilters = letterFilter
      .closest(".panel")
      .querySelectorAll(
        `.letters-container--item:not([data-letter="${letter}"])`
      );
    const associatedBrands = letterFilter
      .closest(".panel")
      .querySelectorAll(`.brand-name[data-letter="${letter}"]`);
    const notAssociatedBrands = letterFilter
      .closest(".panel")
      .querySelectorAll(`.brand-name:not([data-letter="${letter}"])`);

    letterFilter.addEventListener("click", () => {
      const isActive = letterFilter.classList.contains("active");
      if (isActive) {
        letterFilter.classList.remove("active");
        otherLetterFilters.forEach((otherLetterFilter) =>
          otherLetterFilter.classList.remove("hide")
        );
        notAssociatedBrands.forEach((notAssociatedBrands) =>
          notAssociatedBrands.classList.remove("hide")
        );
      } else {
        letterFilter.classList.add("active");
        letterFilter.classList.remove("hide");
        otherLetterFilters.forEach((otherLetterFilter) => {
          otherLetterFilter.classList.add("hide");
          otherLetterFilter.classList.remove("active");
        });
        notAssociatedBrands.forEach((notAssociatedBrand) =>
          notAssociatedBrand.classList.add("hide")
        );
        associatedBrands.forEach((associatedBrand) =>
          associatedBrand.classList.remove("hide")
        );
      }
    });
  });


  if(location.search && location.search.indexOf('?') >= 0) {
    location.search.replace('?', '').split('&').forEach(argString => {
      const arg = argString.split('=');
      if(arg.length > 1 && arg[0] == 'gender') {
        const tab = brandsSection.querySelector(`.tabs__container .tab[data-collection="${arg[1]}"]`);
        if(tab) {
          tab.click();
        }
      }
    });
  }

  calcHeight(
    brandsSection.querySelector(
      ".panel.active .brands-banner__list__group__letters"
    )
  );
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll(".tabs__container"), (el) => {
    window.dAgency.initTabs(el);
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll(".tabs__container"), (el) => {
      window.dAgency.initTabs(el);
    });
  });
}
